module.exports = __webpack_public_path__ + "img/loading.b39c9722.gif";